import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["error", "onRetry", "type"];
import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
export const RecommendationsError = _ref => {
  let error = _ref.error,
    onRetry = _ref.onRetry,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isMobile = useIsMobile();
  if (!error) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    flex: 1,
    direction: "vertical",
    padding: isMobile ? '0 SP4' : '0 48px',
    align: "center",
    verticalAlign: isMobile ? 'middle' : undefined,
    textAlign: isMobile ? 'center' : undefined
  }, props), error === 'NetworkIssue' ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.NetworkIssue, {
    onRetry: onRetry
  }) : error === 'RateLimited' ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.RateLimit, {
    onRetry: onRetry
  }) : error === 'TechnicalIssue' ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.TechnicalIssue, {
    onRetry: onRetry
  }) : /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.NoRecommendations, {
    type: type
  }));
};
//# sourceMappingURL=RecommendationsError.js.map